import axios from 'axios'
import Vue from 'vue'

export async function fetchComentarios(context, payload){
    try{
        let url = "api/comentariosingenieria"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setComentarios', response.data)

    }catch(error){
        context.commit('comentarioError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }

}
